


















import {Component, Prop, Vue} from 'vue-property-decorator';
import ShareSquare from '../assets/share-square.svg';
@Component({
	components: {
		ShareSquare
	}
})
export default class AddToHomescreen extends Vue {
	showOverlayWrapper = false;

	close() {
		this.showOverlayWrapper = false;
	}

	finalClose() {
		this.$emit('close');
	}
}
